import styled from 'styled-components';

import type { CommonFaqProps } from '@wecasa/common/src/types/components';

import Accordion from '../accordion/accordion';
import { type TextStyleProps, textStyle } from '../base-text/base-text';
import Title from '../base-text/variants/title';
import SanitizedHTML from '../sanitized-html/sanitized-html';
import WithSeparators from '../separator/with-separators';

export type FaqProps = CommonFaqProps & {
  className?: string;
};

const SeparatorsContainer = styled(WithSeparators)`
  margin: 20px 0;
`;

const StyledTitle = styled(Title.MD)`
  display: flex;
  margin-bottom: 30px;
`;

const HTMLText = styled(SanitizedHTML)<TextStyleProps>`
  ${textStyle};
`;

const Faq = ({ title: mainTitle, questions, className, ...accordionProps }: FaqProps) => (
  <div className={className}>
    <StyledTitle>{mainTitle}</StyledTitle>
    <SeparatorsContainer>
      {questions.map(({ content, title }) => (
        <Accordion key={title} titleSize='MD' title={title} {...accordionProps}>
          <HTMLText html={content.replace(/(?:\r\n|\r|\n)/g, '<br>')} />
        </Accordion>
      ))}
    </SeparatorsContainer>
  </div>
);

export default Faq;
